import * as React from "react";
import { Form } from "antd";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Button } from "Components/General/Button";
import { SimpleEditor, SimpleEditorInstance } from "Pages/Project/Overview/Components/RichEditor/SimpleEditor";
const FormItem = Form.Item;

export interface SuggestionsConfig extends Array<{ label: string; value: string }> {}

interface AddCommentFormProps extends WithTranslation {
  onSubmit: (comment: API_Comment | string) => Promise<void>;
  initialData?: API_Comment;
  suggestions: SuggestionsConfig;
}

interface AddCommentFormState {
  loading: boolean;
  contentState: string;
}

export const AddCommentForm = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<AddCommentFormProps, AddCommentFormState> {
      editorRef = React.createRef<SimpleEditorInstance>();
      constructor(props: AddCommentFormProps) {
        super(props);

        this.state = {
          contentState: props.initialData ? props.initialData.comment : "",
          loading: false,
        };
      }

      handleSubmit = async (e) => {
        try {
          e.preventDefault();
          this.setState({ loading: true });
          const comment = this.editorRef.current?.getText();
          await this.props.onSubmit(comment);
          // reset input value after successful submit
          this.editorRef.current?.setText("");
        } catch (error) {
          throw error;
        } finally {
          this.setState({ loading: false });
        }
      };

      render() {
        const { loading } = this.state;
        const { t } = this.props;

        return (
          <FormItem
            // help={<small>{t('Use @ to mention somebody')}</small>} DEV-3514 temporary disable hint
            style={{ marginBottom: 20 }}
          >
            <div className="dialog-comment-input-wrap">
              <div className="dialog-comment-input">
                <SimpleEditor
                  initialValue={this.props.initialData?.comment}
                  suggestions={this.props.suggestions}
                  ref={this.editorRef}
                  data-testid="task-detail-comment-input"
                />
              </div>
              <div>
                <Button
                  grey={true}
                  onClick={this.handleSubmit}
                  loading={loading}
                  data-testid="task-detail-comment-send-button"
                >
                  {t("Send")}
                </Button>
              </div>
            </div>
          </FormItem>
        );
      }
    }
  )
);
